module.exports = __webpack_public_path__ + "static/img/san-wei-tu-zhi.5b11d9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/san-wei-tu-zhi.png
// module id = IEKs
// module chunks = 3